/*
 * File: FollowUps.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the main view and header for Patient Follow Ups
 */
import React from "react";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PatientChart from "../topofthechart/PatientChart";
import PropTypes from "prop-types";
import FollowupLinks from "./FollowupLinks";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-4),
    marginTop: theme.spacing(2.5)
  }
});

const FollowUps = ({ classes }) => {
  return (
    <React.Fragment>
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader
          pageTitle="Follow-Ups"
          pageSubtitle="Appointments & Follow-Ups"
        />
      </Toolbar>
      <FollowupLinks />
    </React.Fragment>
  );
};

export default withStyles(styles)(FollowUps);

FollowUps.propTypes = {
  classes: PropTypes.object.isRequired
};
